import type { FaireProductEntity } from "../../entity_types/product";

export const p_ug227p4fxr: FaireProductEntity = {
  token: "p_ug227p4fxr",
  type: "product",
  name: "Non-Toxic Hand Sanitizer Spray | Natural Clean Ingredients",
  brandToken: "b_59txwmdw7j",
  brandName: "MillTown Bath & Candle Company",
  imageUrl:
    "https://cdn.faire.com/fastly/66682a687c9997e032259efaf6a84c110c92bddc15932b6c18aeea0598b29297.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/936a8349421399b00f9980dd1b31f509d94d98baf26df387a6bdfd0ef36906eb.jpeg",
    "https://cdn.faire.com/fastly/6f641664380b11b066601326380c7db85dd613eda571ab528b1bb45c13e690e4.jpeg",
    "https://cdn.faire.com/fastly/9a0867d98b1d1ffb1972fbee5fe98da4ce32a07d69011b70cd57d3cf19d3a336.jpeg",
  ],
  priceDollars: 5.5,
  description:
    "Our hand sanitizer is made with safe, skin-friendly ingredients you can feel good about using all season long. Each small-batch sanitizer is crafted with grain alcohol for effective cleansing and our signature clean fragrance blends for a touch of MillTown holiday cheer — no harsh chemicals or synthetic additives.\n\nWe use an organic solubilizer blend (Caprylyl/Capryl Glucoside, Polyglyeryl-10 Laurate, Water, Glycerin, Polyglyceryl-10 Oleate) that helps disperse fragrance naturally, so your skin stays soft and hydrated — never dry or sticky. Unlike most conventional sanitizers, ours are phthalate-free, non-toxic, and made with simple ingredients that work gently but effectively.\n\nAvailable in Amazing Grace, Melllow & Sea Glass\n\nIngredients: 95% Grain Alcohol, Clean Fragrance, Organic Solubilizer (Caprylyl/Capryl Glucoside, Polyglyeryl-10 Laurate, Water, Glycerin, Polyglyceryl-10 Oleate)\n\nHandmade in Thomaston, Georgia\n",
  tags: [],
  msrpDollars: 10,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:54:41.161Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
